<template>
  <div
    class="calendar-cell relative flex h-10 w-10 cursor-pointer items-center justify-center rounded-xl text-sm font-medium transition-colors duration-200"
    :class="{
      'bg-bgr-secondary hover:bg-bgr-secondary hover:text-fgr-primary': !active && today,
      '!hover:bg-bgr-accent-primary-dark !bg-bgr-accent-primary !text-fgr-white': active && position !== 'middle',
      'bg-bgr-secondary hover:bg-bgr-secondary': active && position === 'middle',
      'hover:bg-bgr-secondary hover:text-fgr-primary': !active && !today,
      'bg-state-bgr-disabled': disabled && (active || today),
      '!text-state-fgr-disabled': disabled,
      'before:content[\'\'] before:absolute before:-z-10 before:h-full': connector != 'none',
      'before:bg-calendar-cell-connector-left before:right-8 before:w-8': connector == 'left',
      'before:bg-calendar-cell-connector-right before:left-full before:w-8': connector == 'right',
      'before:bg-calendar-cell-connector-both before:w-16': connector == 'both',
    }"
  >
    <slot />
    <div v-if="dot" class="absolute bottom-1 flex justify-center">
      <div
        class="h-1.5 w-1.5 rounded-full"
        :class="{
          '': active,
          'bg-bgr-accent-primary-dark': !active && !disabled,
          'bg-state-fgr-disabled': !active && disabled,
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";

  const props = withDefaults(
    defineProps<{
      connector?: "none" | "left" | "right" | "both";
      disabled?: boolean;
      dot?: boolean;
      position?: "leading" | "trailing" | "middle" | null;
      today?: boolean;
    }>(),
    {
      connector: "none",
      disabled: false,
      dot: false,
      position: undefined,
      today: false,
    }
  );

  const active = computed(() => {
    return !!props.position;
  });
</script>
